import React from 'react';

function TrueDesignSettings() {
  return (
    <div>TrueDesignSettings</div>
  );
}

export default TrueDesignSettings;
